module.exports = __webpack_public_path__ + "static/media/SerraLabs_Logo_NewColors.7467fca0.png";